import { render } from "./costConversion.vue?vue&type=template&id=205645f5"
import script from "./costConversion.vue?vue&type=script&lang=js"
export * from "./costConversion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\atschakwizmo\\Arbeit\\Coding\\Wizmo\\dev\\sb_rechner\\ecommerce-kennzahlen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__